export const MAX_ZOOM = 17;

export const COORD_MATCH_TOLERANCE = 0.0001;
